import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter5() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          So Dr. Demir and her team started asking: “What are the watermarks of being human in real
          videos?” Some of these watermarks include heartbeat, gaze, head pose, and corneal light
          reflection. For example, if a video subject has light reflections in their eyes from
          windows or a lamp, researchers look at whether they’re consistent between the two eyes and
          along some time interval. And it’s not just light reflection that can be detected. “
          <a
            href="https://dl.acm.org/doi/10.1145/3448017.3457387"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            In our gaze-based detector
          </a>
          , we are not only looking at the color, shape, and size of your iris, eye, and pupil, but
          we are also looking at the 3D gaze information,” she says. When you look at a certain
          point, Dr. Demir explains, “imagine that rays are being shot from your eyes. The rays will
          converge on a point, and they’ll be on the same plane. But for deepfakes, they are not
          even co-planar. It's like googly eyes, you know?”
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            "When you look at a certain point, imagine that rays are being shot from your eyes. The rays will converge on a point, and they’ll be on the same plane. But for deepfakes, they are not even co-planar. It's like googly eyes, you know?  "
          }
          author={'Dr. Ilke Demir,'}
          source={'Intel Labs'}
        />
      </section>
      <section className="chapter">
        <p className="chapter__paragraph">
          These are the kind of very subtle signals that researchers are training AI to detect. Dr.
          Ciftci’s work in detecting deepfakes also focuses on the biological signals of being
          human. His research with Dr. Demir on FakeCatcher involves skin color changes. “The main
          signal that we use in FakeCatcher is mostly the small color changes that are happening on
          our skin caused by the beating of the heart,” Dr. Ciftci says. Blood traveling through our
          bodies is close to the skin on our faces so it can be detected by cameras. Depending on
          timing and vein size, real humans exhibit minute color and motion changes on video that
          deepfake or CGI humans will not display. As oxygen levels change in your veins, the color
          of your veins changes.
        </p>
      </section>
    </>
  );
}

export default Chapter5;
